<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="FMH"><span class="ePub-I">Contents</span></p>
<p class="sp1"> </p>
<p class="toc"><span href="#/xhtml/title" title="Link target outside of Sample">Title Page</span></p>
<p class="toc"><span href="#/xhtml/copyrightnotice" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="toc1"><span href="#/xhtml/dedication" title="Link target outside of Sample">Dedication</span></p>
<p class="toc"><a href="#/xhtml/chapter1#ch1">1. Interview</a></p>
<p class="toc"><a href="#/xhtml/chapter2#ch2">2. A Cunning Plan</a></p>
<p class="toc"><span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample">3. Complete Again</span></p>
<p class="toc"><span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">4. Stalking the Wyvern</span></p>
<p class="toc"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">5. The Last of the Ironskin (Nearly)</span></p>
<p class="toc"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">6. The Queen’s Lab</span></p>
<p class="toc"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">7. Catching Silver</span></p>
<p class="toc"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">8. Doing Good</span></p>
<p class="toc"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">9. All the Things We Hide</span></p>
<p class="toc"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">10. Dusting</span></p>
<p class="toc"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">11. Going Home</span></p>
<p class="toc"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">12. Subversive Activities</span></p>
<p class="toc"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">13. Basilisk</span></p>
<p class="toc"><span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">14. Belief</span></p>
<p class="toc"><span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">15. The Way Through</span></p>
<p class="toc1"><span href="#/xhtml/epigraph" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc"><span href="#/xhtml/acknowledgments" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc"><span href="#/xhtml/adcard" title="Link target outside of Sample">Tor Books by Tina Connolly</span></p>
<p class="toc"><span href="#/xhtml/abouttheauthor" title="Link target outside of Sample">About the Author</span></p>
<p class="toc"><span href="#/xhtml/copyright" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?031b6ede